    const specificationsData = [
    {
        paroductName:'NVMD-C200',
        specifications:[
            { 
                specificRow:'Sensor Specifications',
                data:[
                    {title:'Resolution',param:'1920 × 1080 pixels'},
                    {title:'Sensor Frame Rate',param:'50 fps'},
                    {title:'Recording Format',param:'1920 × 1080 pixels @ 50 FPS'}
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Digital Magnification',param:'1-6x'},
                    {title:'Eye Relief',param:'65 mm / 2.6 in'},
                    {title:'Field of View',param:'27.0° × 15.4° / 48 yd × 27 yd @100 yd'},
                    {title:'Diopter Adjustment',param:'±2D'}
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1920 × 1080 pixels'},
                    {title:'Frame Rate',param:'50 Hz'}
                ]
            },
            { 
                specificRow:'Battery Power Supply',
                data:[
                    {title:'Battery Type',param:'18650 Battery (Flat-top)'},
                    {title:'Operating Time',param:'6 h'},
                    {title:'External Power Supply',param:'5V USB-C'}
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'390 g / 13.76 oz'},
                    {title:'Total Weight (incl. Battery & QDS-150)',param:'Approx. 587 g / 20.71 oz'},
                    {title:'Dimensions',param:'99 × 73 × 63mm / 3.9 × 2.9 × 2.5 in'},
                    {title:'Built-in Memory',param:'32 GB eMMC'},
                    {title:'Ingress Protection Rating',param:'IP67'},
                    {title:'Recoil Rating',param:'800 Gs / .50 BMG'},
                    {title:'Connections /App',param:'Wi-Fi/ DNT APP'}
                ]
            }
        ]
    },
    
    {
        paroductName:'ZT4K324R',
        specifications:[
            { 
                specificRow:'Sensor Specifications',
                data:[
                    {title:'Resolution',param:'3840 × 2160 pixels'},
                    {title:'Sensor Frame Rate',param:'60fps @ 1080P / 30fps @ 4K'},
                    {title:'Recording Format',param:'1920 × 1080 pixels'}
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Digital Magnification',param:'3 - 24x'},
                    {title:'Eye Relief',param:'65 mm / 2.6 in'},
                    {title:'Field of View',param:'8.8° × 4.9° / 15.4 yd × 8.6 yd @100 yd'},
                    {title:'Diopter Adjustment',param:'±3D'}
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1920 × 1080 pixels'},
                    {title:'Frame Rate',param:'60 Hz'}
                ]
            },
            { 
                specificRow:'Battery Power Supply',
                data:[
                    {title:'Battery Type',param:'21700 Battery (Flat-top)'},
                    {title:'Operating Time',param:'6 h'},
                    {title:'External Power Supply',param:'5V USB-C'}
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'690 g / 24.3 oz'},
                    {title:'Total Weight (incl. Battery & Rings)',param:'Approx. 895 g / 29.5 oz'},
                    {title:'Dimensions',param:'347 × 83 × 65mm / 11.4 × 2.7 × 2.1 in'},
                    {title:'Built-in Memory',param:'64 GB eMMC'},
                    {title:'Ingress Protection Rating',param:'IP67'},
                    {title:'Recoil Rating',param:'800 Gs / .50 BMG'},
                    {title:'Connections /App',param:'Wi-Fi / DNT APP'}
                ]
            }
        ]
    }
]